export const initialState = {
    preNotificationAvailable: false,
    preNotificationCookie: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'PRE_NOTIFICATION_AVAILABLE':
            return {
                ...state,
                preNotificationAvailable: action.value };
        case 'PRE_NOTIFICATION_COOKIE':
            return {
                ...state,
                preNotificationCookie: action.value };
        default:
            return state;
    }
};
